import { ChevronRightIcon } from "~/icons";
import type { ProductCategory } from "~/types";
import { Box } from "../Box/Box";
import { Column } from "../Column/Column";
import { Columns } from "../Columns/Columns";
import { Modal } from "../Modal/Modal";
import { Stack } from "../Stack/Stack";
import { Text } from "../Text/Text";
import styles from "./CategorySelectionModal.module.css";

export function CategorySelectionModal({
  menu,
  open,
  onClose,
  onSelectCategory,
}: {
  menu: ProductCategory[];
  open: boolean;
  onClose: () => void;
  onSelectCategory: (category: ProductCategory) => void;
}): React.ReactNode {
  return (
    <Modal open={open} onClose={onClose} title="Menu">
      <Box paddingBottom="4">
        <Stack space="2">
          {menu.map((category) => {
            return (
              <Box
                key={category.id}
                borderRadius="standard"
                paddingX="3"
                paddingY="1"
                className={styles.category}
                onClick={() => {
                  onSelectCategory(category);
                }}
              >
                <Columns space="2" alignY="center">
                  <Column>
                    <Text size="large" weight="regular">
                      {category.title}
                    </Text>
                  </Column>
                  <Column width="content">
                    <ChevronRightIcon
                      className={styles.categoryIcon}
                      width={35}
                      height={35}
                    />
                  </Column>
                </Columns>
              </Box>
            );
          })}
        </Stack>
      </Box>
    </Modal>
  );
}
